import './blocks/media.js'; // Import the media block script
import './blocks/media-carousel.js'; // Import the media carousel block script
import { gsap } from "gsap";
import ScrollToPlugin from "gsap/dist/ScrollToPlugin";

var $ = jQuery;
$(document).ready(function ($) {
    // Register GSAP plugin
    gsap.registerPlugin(ScrollToPlugin);

    // Scroll effect removed - menu stays visible at all times

    $("#menu_trigger").on("click", function () {
        $("body").toggleClass("stop");
        $(".navigation-wrapper").toggleClass("active");
    });

    // Smooth scroll for anchor links in navigation
    $('.primary-menu a[href*="#"]').on('click', function (e) {
        var hash = this.hash;

        // Only handle links with hash that point to an element on the same page
        if (hash && $(hash).length) {
            $("body").removeClass("stop");
            $(".navigation-wrapper").removeClass("active");
        }
    });

    // Smooth scroll on page load if there's a hash in the URL
    if (window.location.hash) {
        var hash = window.location.hash;

        // Wait for page to fully load before scrolling
        setTimeout(function() {
            if ($(hash).length) {
                // Prevent default jump
                $('html, body').scrollTop(0);

                // Smooth scroll to target using GSAP
                gsap.to(window, {
                    duration: 0.8,
                    scrollTo: {
                        y: $(hash).offset().top,
                        autoKill: true
                    },
                    ease: "power2.inOut"
                });
            }
        }, 100);
    }
});


$(window).on('resize', function () {
});

$(window).on('click', function () {
});

$(window).on('scroll', function () {
});


document.querySelectorAll('a[href^="#"]').forEach(anchor => {
	anchor.addEventListener('click', function (e) {
		const targetId = this.getAttribute('href');
		if (targetId.length > 1) { // make sure it's not just "#"
			e.preventDefault();
			const target = document.querySelector(targetId);
			if (target) {
				target.scrollIntoView({
					behavior: 'smooth'
				});
			}
		}
	});
});
